module.exports = __webpack_public_path__ + "static/media/FS_Lab_Radiology_letterhead_Upated_footer_July_1_2000x301.bcfcf640.jpeg";